export enum ESFCCAssetType {
	DWANALYTICS,
	DWAC
}
